//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CalculationSetting } from "./calculation-setting";

export class Constant extends CalculationSetting {
    value?: string;
}
